import { Box, Group, Text, Tooltip } from '@mantine/core';
import IconQuestionMark from '@tabler/icons-react/dist/esm/icons/IconQuestionMark.mjs';
import { useTranslation } from 'react-i18next';

export function SystemNameLabel({ label }: { label?: string }) {
  const { t } = useTranslation(['system-name-label']);

  const tooltip = (
    <Box component='ul' m={0} pl='md' style={{ lineHeight: 1.35 }}>
      <Text component='li' size='sm'>
        {t('system-name-label:tooltip.systemUsage')}
      </Text>
      <Text component='li' size='sm'>
        {t('system-name-label:tooltip.allowedCharacters')}
      </Text>
      <Text component='li' size='sm'>
        {t('system-name-label:tooltip.unique')}
      </Text>
      <Text component='li' size='sm'>
        {t('system-name-label:tooltip.immutable')}
      </Text>
    </Box>
  );

  return (
    <Group gap={4} wrap='nowrap' align='center'>
      <span>{label || t('system-name-label:label')}</span>
      <Text
        component='span'
        c='var(--mantine-color-error)'
        inherit
        aria-hidden='true'
      >
        *
      </Text>
      <Tooltip label={tooltip} multiline w={360} withArrow>
        <span
          aria-label={t('system-name-label:tooltip.iconLabel')}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 16,
            height: 16,
            borderRadius: '50%',
            border: '1px solid var(--mantine-color-gray-4)',
            color: 'var(--mantine-color-gray-6)',
            cursor: 'help',
          }}
        >
          <IconQuestionMark size={14} />
        </span>
      </Tooltip>
    </Group>
  );
}